import MobileRegistrationComponent from '../components/MobileRegistrationComponent';

export default function RegisterMobile() {
    return (
        <div className="analytics-container mobile-registration">
            <MobileRegistrationComponent />
        </div>
    );
}